<template>
  <TableTemplate
    v-model="tableResult"

    :columns="websiteColumns"
    :columnVariables="websiteColumnVariables"
    :capitalize="capitalize"
    :skeletonClass="skeletonClass"

    :page="page"
    :enable-sorting="true"

    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"
    :on-row-click="editSize"

    :max="max"

    ref="table"
  >
    <template #above>
      <TableHeader
        title="Maat"
        :alwaysShowMultiSelectCheckbox="true"
        :removeColumnConfiguration="true"
        :exportParams="exportEndpointParams"
        :refetch="refetch"

        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
        <template #after-title>
          <HeaderButton class="ml-2"
            buttonTypeClass="btn-outline-primary btn-primary-secondary-outline"
            style="padding: 11px 8px"
            @click.native="addSize"
          >
            Maat toevoegen
          </HeaderButton>
        </template>
      </TableHeader>

      <div class="d-flex">
        <TableMainSearchField v-model="search"/>
        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>
    </template>

    <template v-if="loaded" #row-action="{item}">
      <div class="delete-icon" @click="confirmDelete(item)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </div>
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        title="Er is geen maat"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M18 3a1 1 0 00-1.447-.894L8.763 6H5a3 3 0 000 6h.28l1.771 5.316A1 1 0 008 18h1a1 1 0 001-1v-4.382l6.553 3.276A1 1 0 0018 15V3z" clip-rule="evenodd" />
        </svg>
      </EmptyStatePlaceholder>
    </template>
  </TableTemplate>

</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import HeaderButton from "src/components/Inputs/HeaderButton.vue"
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import RefreshBtn from '../layout/RefreshBtn.vue'

import TableCell from "src/components/Table/TableCell.vue"

import table from "src/mixins/table"

export default {
  metaInfo: {
    title: "Maat",
  },
  components: {
    TableCell,
    TableMainSearchField,
    TableTemplate,
    TableSearchField,
    TableHeader,
    TableActionDropdown,
    RefreshBtn,
    EmptyStatePlaceholder,
    HeaderButton,
  },
  mixins: [
    tableFieldOptions,
    table({
      pageReference: 'sizes',

      params: {
        name: "",
        sku: null,
        price: 0,
        website: "",
        search: "",
      },
      route: "/api/sizes",
    }),
  ],
  methods: {
    addSize() {
      this.$pushModal({
        modal: "EditSize",
        toBind: {
          callback: this.freshRefetch,
        },
      })
    },
    editSize(size) {
      this.$pushModal({
        modal: "EditSize",
        toBind: {
          size: this.tableResult.find(item => item.uid === size.uid),
          callback: this.freshRefetch,
        },
      })
    },
    async deleteSize(uid) {
      await this.$handlePromise(
        this.axios.delete(`/api/sizes/${uid}`)
      )
      this.$store.dispatch('clearCacheSearch', "sizes")
      this.$success("Productgroup succesvol verwijderd!")
      this.freshRefetch()
    },
    confirmDelete(item) {
      this.$confirmAction(
        () => this.deleteSize(item.uid),
        {
          title: "Productgroup verwijderen",
          description: `Are you sure you want to delete the <b>${item.name}</b> product group?`,
          buttonSave: "Verwijderen",
        }
      )
    },
  },
  computed: {
    table() {
      return this.$refs.table
    },
    websiteColumns() {
      return ['Maat']
    },
    websiteColumnVariables() {
      return ['name']
    },
    capitalize() {
      return [false]
    },
  },
}

</script>
